import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import JoditEditor from "jodit-react";
import joditOptions from "../joditOptions";

interface Props {
  initialText?: string;
  title?: string;
  submitText?: string;

  open: boolean;
  visibilityChanged: (open: boolean) => void;

  submit: (text: string) => Promise<void>;
}

export default function AssistedText(props: Props) {
  const { t } = useTranslation();
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    if (props.initialText || (!props.initialText && value !== "")) {
      setValue(props.initialText ?? "");
    }
  }, [props.initialText]);

  const close = () => {
    props.visibilityChanged(false);
  };

  const config = useMemo(joditOptions, []);

  return (
    <Dialog
      open={props.open}
      onClose={close}
      fullWidth={true}
      maxWidth="lg"
      PaperProps={{
        component: "form",
        onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          await props.submit(value);
          close();
        },
      }}
    >
      {props.title && <DialogTitle>{props.title}</DialogTitle>}
      <DialogContent>
        {/* <TextField autoFocus required margin="dense" id="text" name="text" type="text" multiline rows={15} fullWidth /> */}

        <JoditEditor config={config} value={value} onBlur={(newText) => setValue(newText)} />
      </DialogContent>
      <Box mr={2} mb={2}>
        <DialogActions>
          <Button onClick={close}>{t("common.cancel")}</Button>
          <Button variant="contained" type="submit" disabled={value.length === 0}>
            {props.submitText}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
